// Generated by generate/render-markdown.ts. Do not edit.
export interface PublishedPackage {
  name: string; version: string; description: string; path: string;
}
export const packages: PublishedPackage[] = [
  {
    "name": "@openresult/core",
    "version": "1.0.2",
    "description": "Read, inspect and rank OpenResult documents. Dependency-free by contract.",
    "path": "sdk/js/packages/core"
  },
  {
    "name": "@openresult/validate",
    "version": "1.0.2",
    "description": "Validate OpenResult documents against the official schema and semantic rules.",
    "path": "sdk/js/packages/validate"
  },
  {
    "name": "@openresult/viewer",
    "version": "1.0.2",
    "description": "Embeddable web component that renders any OpenResult document, with no configuration.",
    "path": "viewer"
  },
  {
    "name": "@openresult/cli",
    "version": "1.0.2",
    "description": "Command-line validator and ranker for OpenResult documents.",
    "path": "validator/cli"
  }
];
